import React from "react";
import { Reveal } from "@/components/Reveal";
import { Award, MapPin, Home } from "lucide-react";

const badges = [
  { icon: Award, label: "Kinetico Authorized", sub: "Independent Dealer" },
  { icon: Home, label: "Family-Owned", sub: "Local Kinetico Dealer" },
  { icon: MapPin, label: "N. Utah · S. Idaho", sub: "Full-service coverage" },
];

export default function TrustBadges() {
  return (
    <section
      className="relative py-20 lg:py-24 px-6 lg:px-10 border-t border-[color:var(--border)]"
      data-testid="trust-badges"
    >
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <div className="text-[11px] uppercase tracking-[0.4em] text-[color:var(--blue)] mb-10">
            Trusted &amp; Certified
          </div>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-10">
          {badges.map((b, i) => {
            const Icon = b.icon;
            return (
              <Reveal key={b.label} delay={0.05 * i}>
                <div className="flex flex-col gap-4 pt-6 border-t border-[color:var(--border)]">
                  <Icon className="h-6 w-6 text-[color:var(--blue)]" />
                  <div>
                    <div className="font-display text-xl lg:text-2xl font-semibold text-white leading-tight">
                      {b.label}
                    </div>
                    <div className="mt-2 text-[11px] uppercase tracking-[0.25em] text-[color:var(--muted)]">
                      {b.sub}
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
